(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-collection-map-link]');
    if (!link) return;
    const url = new URL(link.href);
    for (const [key, value] of new URLSearchParams(location.search)) {
      if (key.startsWith('filter.') || key === 'sort_by') url.searchParams.append(key, value);
    }
    event.preventDefault();
    location.assign(url.href);
  });
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preciso-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('preciso-footer-navigation')) {
    customElements.define('preciso-footer-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.desktop = window.matchMedia('(min-width: 750px)');
        const update = () => {
          this.querySelectorAll('details').forEach((details) => { details.open = this.desktop.matches; });
        };
        this.desktop.addEventListener('change', update, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const details = event.target.closest('.preciso-footer__group')?.querySelector('details');
          if (details) details.open = true;
        }, { signal });
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
